import React, { useState, useRef, useEffect } from 'react';
import { updateTestCaseStatus } from '../services/api';
import CommentModal from './CommentModal';

const STATUTS = ['NT', 'EC', 'OK', 'KO', 'BL'];
const LABELS = { NT: 'Non Teste', EC: 'En Cours', OK: 'OK', KO: 'KO', BL: 'Bloque' };

export default function StatusBadge({ projectId, testCaseId, statut, commentaire, attachments = [], onUpdate, environment = 'DEV' }) {
  const [show, setShow] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [commentModal, setCommentModal] = useState(null); // statut en attente
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setShow(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleChange = async (newStatut) => {
    if (updating) return;
    if (newStatut === 'KO' || newStatut === 'BL') {
      setShow(false);
      setCommentModal(newStatut);
      return;
    }
    setUpdating(true);
    try {
      await updateTestCaseStatus(projectId, testCaseId, newStatut, undefined, environment);
      setShow(false);
      if (onUpdate) onUpdate();
    } catch { /* handled by interceptor */ }
    setUpdating(false);
  };

  const handleCommentSubmit = async (comment) => {
    setUpdating(true);
    try {
      await updateTestCaseStatus(projectId, testCaseId, commentModal, comment || undefined, environment);
      setCommentModal(null);
      if (onUpdate) onUpdate();
    } catch { /* handled by interceptor */ }
    setUpdating(false);
  };

  return (
    <div className="position-relative d-inline-block" ref={ref}>
      <button
        type="button"
        className={`status-badge status-${statut}`}
        onClick={() => setShow(!show)}
        title="Cliquer pour changer le statut"
        style={{ background: 'none', border: 'none', font: 'inherit', color: 'inherit', padding: 0, cursor: 'pointer' }}
      >
        {statut}
      </button>
      {show && (
        <div className="status-dropdown">
          {STATUTS.map((s) => (
            <button
              type="button"
              key={s}
              className={`status-dropdown-item ${s === statut ? 'fw-bold' : ''}`}
              onClick={() => handleChange(s)}
              style={{ background: 'none', border: 'none', font: 'inherit', color: 'inherit', textAlign: 'left', width: '100%', padding: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
            >
              <span className={`status-badge status-${s}`}>{s}</span>
              {LABELS[s]}
            </button>
          ))}
        </div>
      )}
      <CommentModal
        show={!!commentModal}
        onClose={() => setCommentModal(null)}
        onSubmit={handleCommentSubmit}
        initialComment={commentaire || ''}
        statut={commentModal || 'KO'}
        loading={updating}
        projectId={projectId}
        testCaseId={testCaseId}
        attachments={attachments}
        onAttachmentChange={onUpdate}
      />
    </div>
  );
}
